import { render, staticRenderFns } from "./menuButton.vue?vue&type=template&id=3d4454e9&scoped=true"
import script from "./menuButton.vue?vue&type=script&lang=js"
export * from "./menuButton.vue?vue&type=script&lang=js"
import style0 from "./menuButton.vue?vue&type=style&index=0&id=3d4454e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4454e9",
  null
  
)

export default component.exports